export default __webpack_public_path__ + "static/playmarket_ja-e0cdcafc46b33c1206e54dd639996b73.png";